// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 691 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"691":"cb39741709f32e7daa3b","731":"b5697f9c99fabff21012","843":"ec4302638027797cca24"}[chunkId] + ".js";
};